// Map API status to tile border color (using CSS variables from :root)
export const STATUS_COLORS = {
  PASSED: "passed",
  WARNING: "warning",
  FAILED: "failed",
  NO_DATA: "noData",
};

// Device State
export const DXH_DEVICE_STATE_ADD = "DXH_DEVICE_STATE_ADD";
export const DXH_DEVICE_STATE_REMOVE = "DXH_DEVICE_STATE_REMOVE";

// Generic screen actions (screenKey in payload routes to the right slot)
export const DXH_SCREEN_FETCH_REQUEST = "DXH_SCREEN_FETCH_REQUEST";
export const DXH_SCREEN_FETCH_SUCCESS = "DXH_SCREEN_FETCH_SUCCESS";
export const DXH_SCREEN_FETCH_ERROR = "DXH_SCREEN_FETCH_ERROR";

// Pagination append
export const DXH_FETCH_PAGE_APPEND = "DXH_FETCH_PAGE_APPEND";

// Dashboard tile status (cached per device)
export const DXH_DASHBOARD_STATUS_SUCCESS = "DXH_DASHBOARD_STATUS_SUCCESS";

// Cycle Count
export const CYCLE_COUNT_RESET_REQUEST = "CYCLE_COUNT_RESET_REQUEST";
export const CYCLE_COUNT_RESET_SUCCESS = "CYCLE_COUNT_RESET_SUCCESS";
export const CYCLE_COUNT_RESET_ERROR = "CYCLE_COUNT_RESET_ERROR";
export const CYCLE_COUNT_COLUMNS = [
  { field: "activity", label: "Activity" },
  { field: "count", label: "Cycles" },
  { field: "insertDate", label: "From" },
  { field: "updateDate", label: "To" },
];

// QC Summary statistics fields
export const QC_SUMMARY_STAT_FIELDS = [
  { key: "n", label: "N:" },
  { key: "mean", label: "MEAN:" },
  { key: "twoSd", label: "2SD:" },
  { key: "cv", label: "%CV:" },
  { key: "assigned", label: "ASSIGNED:" },
  { key: "expected", label: "(±) EXPECTED:" },
  { key: "meanDeltaValue", label: "DELTA:" },
  { key: "percentageIn", label: "%IN:" },
  { key: "map", label: "LEVEY-JENNINGS:" },
];

// QA tiles to exclude from the dashboard (API may still return them)
export const EXCLUDED_QA_TILES = ["S-CAL"];

// QA tiles to exclude per model prefix (uppercase key)
export const EXCLUDED_QA_TILES_BY_MODEL = {
  DXH800: ["6C PLUS CELL"],
};

// Instrument model identifiers
export const DXHSMS_MODEL_PREFIX = "DXHSMS";

// QC summary: params whose Assigned/Expected cells should be hidden
export const HIDE_FOR_METRIC_PARAMS = ["Total Events", "Elapsed Time"];
export const HIDE_VALUE_FOR_ROWS = ["assigned", "expected"];

// Summary column order (DXHSMS)
export const SUMMARY_COLUMN_ORDER = ["Shutdown Time", "System", "Supplies", "Slidemaker", "Slidestainer"];

// Rename API keys to display labels for Summary columns
export const SUMMARY_LABEL_REMAP = {
  "Electrical Power Supply": "System",
};

export const BACKGROUND_COLUMN_ORDER = {
  WBC: 1,
  RBC: 2,
  HGB: 3,
  PLT: 4,
  DIFF: 5,
  RETIC: 6,
  "NRBC Total": 7,
  "NRBC Region": 8,
};

// System status fields whose values use 1/0 ramp-status mapping
export const RAMP_STATUS_NAMES = ["VCSn Ramp", "CBC Ramp"];

// Supplies sub-column definitions
export const SUPPLIES_SUB_COLUMNS = [
  { valueKey: "Product Name", label: "Name" },
  { valueKey: "Lot Number", label: "Lot#" },
  { valueKey: "Expiration Date", label: "Exp. Date", isExpiry: true },
  { valueKey: "BCI Reagent", label: "BCI Reag." },
];

export const SUPPLIES_SUB_COLUMNS_DXHSMS = [
  { valueKey: "Product Name", label: "Name" },
  { valueKey: "Lot Number", label: "Lot#" },
  { valueKey: "Open Expiration Date", label: "Open Exp. Date", isExpiry: true },
  { valueKey: "Lot Expiration Date", label: "Exp. Date", isExpiry: true },
  { valueKey: "BCI Reagent", label: "BCI Reag." },
];

// Range filter options
export const RANGE_OPTIONS = [
  { label: "In Range", value: "inRange" },
  { label: "Out of Range", value: "outRange" },
];

// Date filter options (week-based)
export const DATE_FILTER_OPTIONS = [
  { value: "1", label: "Last 1 Week" },
  { value: "2", label: "Last 2 Weeks" },
  { value: "3", label: "Last 3 Weeks" },
  { value: "4", label: "Last 4 Weeks" },
  { value: "5", label: "Last 5 Weeks" },
  { value: "6", label: "Last 6 Weeks" },
  { value: "7", label: "Last 7 Weeks" },
];

export const MAX_DATE_RANGE_DAYS = 7;

// Common
export const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
